"use strict";
const createSearchStringQuery = searchString => ({
    or: [
        {
            keywords: {
                iLike: `%${searchString.replace(' ', '')}%`,
            },
        },
        {
            outgoingChannel: {
                iLike: `%${searchString.replace(' ', '')}%`,
            },
        },
    ],
});
module.exports = createSearchStringQuery;
